export const statusOptions = {
  NORMAL: 'NORMAL',
  DOWN: 'DOWN',
};

const initialState = {
  status: statusOptions.NORMAL,
  consecutive_failures: 0,
};

export default initialState;
